module.exports = __webpack_public_path__ + "static/story3-cta-1920x515-e56d8483933b9dc55a15a33138481141.jpg";